export default {
  name: 'dashify:SingleValue',
  title: 'Single Value',
  owner: 'System',
  solution: '',
  tags: ['widget', 'numeric', 'single value'],
  createdAt: 'May 30, 2023, 10:14 AM',
  modifiedAt: 'July 21, 2023, 2:34 PM',
  spec: {
    props: {
      title: '',
      data: null,
      unit: '',
      href: '',
      valueTextSize: 'text-2xl',
      titleTextSize: 'text-xl',
      subTitleTextSize: 'text-xs',
      shortFormat: true,
      showDelta: false,
      compareAsPercent: false,
      comparisonStart: 'RECENT',
      showDescription: false,

      alignment: 'LEFT',
      colorZones: [],
      backgroundColorClassName: '',
      titleColorClassName: '',
      valueColorClassName: '',
      drillDownHoverColorClassName: '',
      descriptionColorClassName: '',
      unitColorClassName: '',
    },
    dataType: '/${ $type(props.data) }',
    view: [
      [
        'div',
        {},
        [
          [
            'dashify:Switch',
            {},
            [
              [
                'dashify:Case',
                { condition: "/${ dataType = 'array' }" },
                [['dashify:SingleValueArray', '/${ props }']],
              ],
              [
                'dashify:Case',
                { condition: "/${ dataType = 'string' }" },
                [['dashify:SingleValueString', '/${ props }']],
              ],
              [
                'dashify:Case',
                { condition: "/${ dataType = 'number' or dataType = 'null' }" },
                [['dashify:SingleValueNumber', '/${ props }']],
              ],
              ['dashify:Default', {}, [['p', { '.': '' }, 'Not acceptable data format']]],
            ],
          ],
        ],
      ],
    ],
  },
};
